import { render } from "./PersonaContactoList.vue?vue&type=template&id=1448b806&scoped=true"
import script from "./PersonaContactoList.vue?vue&type=script&lang=js"
export * from "./PersonaContactoList.vue?vue&type=script&lang=js"

import "./PersonaContactoList.vue?vue&type=style&index=0&id=1448b806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1448b806"]])

export default __exports__